import React from "react";
import useOverViewRecheck from "./useOverViewRecheck";
import Style from "./oveview.module.scss";
import GliCardListing from "../../Global/GliCardLIsting";
import QCCardListing from "./QCCardLIsting";
import {
  Button,
  DatePickerWithInput,
  ModalLayout,
} from "@wac-ui-dashboard/wac_component_library";
import "react-datepicker/dist/react-datepicker.css";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import FilterForm from "./FilterForm";
import CardDetails from "../OverView/CardDetails";
import SubCards from "../OverView/SubCards";
import FilterButton from "../../Global/FilterButton";

const OverViewRecheck = () => {
  const {
    states,
    state,
    dataArray,
    date,
    apiStatus,
    totalLength,
    isLoading,
    scrollRef,
    inputData,
    filterCount,
    handleClick,
    handleInputSearch,
    handleSearch,
    handleCardView,
    setIsLoading,
    handleLoadMore,
    handleDateChange,
    handleClearClick,
    handleFilterModal,
  } = useOverViewRecheck();

  return (
    <>
      <div className={Style.varifaication_main_wrap}>
        <div className="row">
          <div className={`col ${Style.card_main_wrapper}`}>
            {/* sura didn't added filter in wac pro  */}
            {/* <SearchFilters
              showDateRange={true}
              onSearchInput={handleSearch}
              showFilters={true}
              showActions={false}
              showAdvancedFilterButton={true}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              onDateChange={handleDateChange}
              showClearFilters={true}
              handleClear={handleClearClick}
              initialDateRange={date}
            /> */}
            <div className="row gx-2 gy-2 flex-fill">
              <div className={`col-auto`}>
                <div className="input-wrap">
                  <input
                    type="text"
                    onChange={(e) => {
                      handleInputSearch(e?.target?.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch(); // Trigger search on Enter key
                      }
                    }}
                    placeholder="Search GLI Number"
                    className={`pro-input icon-r lg search-input ${Style.search_table}`}
                    value={inputData}
                  />
                  <span className="pro-icon">
                    {<span className="material-symbols-outlined">search</span>}
                  </span>
                </div>
              </div>
              <div className={`col-auto`}>
                <button
                  className="pro-btn pro-btn-primary "
                  onClick={handleSearch}
                  type="button"
                >
                  <span className="material-symbols-outlined">search</span>
                  Search
                </button>
              </div>
              <div className={`col-auto`}>
                <DatePickerWithInput
                  CalendarOutlineIcon={
                    <span className="material-symbols-outlined">
                      calendar_month
                    </span>
                  }
                  range={true}
                  initialValue={date}
                  onDateChange={handleDateChange}
                ></DatePickerWithInput>
              </div>
              <div className={`col-auto`}>
                <FilterButton
                  onClick={handleFilterModal}
                  filterCount={filterCount}
                  label="Filters"
                />
              </div>
              <div className={`col-auto`}>
                <Button
                  className={"pro-btn-link lg pro-px-5"}
                  onClick={handleClearClick}
                >
                  Clear
                </Button>
              </div>
            </div>
            <ModalLayout
              show={state?.filterModal}
              title={"Filter"}
              handleClose={handleFilterModal}
            >
              <FilterForm />
            </ModalLayout>
            <ModalLayout
              show={state?.viewModal}
              title={"GLI Work Status"}
              handleClose={handleCardView}
              propStyle={{ root: Style.modal_root }}
              closeIcon={
                <span className="material-symbols-outlined">close</span>
              }
            >
              <CardDetails />
            </ModalLayout>
            <ModalLayout
              show={state?.viewSubModal}
              title={"Stock Receipt Details"}
              handleClose={handleClick}
              propStyle={{ root: Style.modal_root }}
              closeIcon={
                <span className="material-symbols-outlined">close</span>
              }
            >
              <SubCards />
            </ModalLayout>
            <div className={`${Style.card_scroll_wrap} pro-mt-3`}      ref={(ref) => (scrollRef.current = ref)}>
              <div className={`pro-d-flex ${Style.card_flow_wrap}`}>
                {states?.length === 0 ? null : (
                  <GliCardListing
                    isOverView
                    title={"GLI Status"}
                    extraClassName={Style.glicard_list}
                    data={states}
                    apiStatus={apiStatus}
                    totalLength={totalLength}
                    isLoading={isLoading}
                    scrollRef={scrollRef}
                    setIsLoading={setIsLoading}
                    handleLoadMore={handleLoadMore}
                    handleChange={handleClick}
                  />
                )}
                {dataArray.map((data, index) => (
                  <QCCardListing
                    data={data.data}
                    dataKey={data.key}
                    title={data.title}
                    key={index}
                    handleChange={handleCardView}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OverViewRecheck;
